import MatchedMap from 'utilities/src/matchedMap';

import { SiteVariantEnum } from '../../_variants';
import { SiteSizeEnum, type SiteSizeType } from '../../_size';

const buttonClassesMap = new MatchedMap([
  [SiteVariantEnum.Primary, 'text-site-neutrals-0'],
  [SiteVariantEnum.Secondary, 'border-site-secondary-green-600'],
  [SiteVariantEnum.Tertiary, 'text-site-secondary-green-700'],
  [SiteVariantEnum.TextOnly, 'text-site-secondary-green-700'],
]);

const buttonHoverClassesMap = new MatchedMap([
  [SiteVariantEnum.Primary, ''],
  [SiteVariantEnum.Secondary, 'hover:bg-site-secondary-green-600'],
  [SiteVariantEnum.Tertiary, ''],
  [SiteVariantEnum.TextOnly, 'hover:text-site-secondary-green-800'],
]);

const buttonActiveClassesMap = new MatchedMap([
  [SiteVariantEnum.Primary, 'active:bg-site-secondary-green-800'],
  [SiteVariantEnum.Secondary, 'active:border-site-secondary-green-800'],
  [SiteVariantEnum.Tertiary, 'active:text-site-secondary-green-800'],
  [SiteVariantEnum.TextOnly, 'active:text-site-secondary-green-800'],
]);

const buttonShadowClasses = 'focus:shadow-site-secondary-green-50';

/**
 * Size per Variants
 */

const buttonPrimarySizeClassesMap = new MatchedMap([
  [SiteSizeEnum.Small, 'bg-site-secondary-green-700 hover:bg-site-secondary-green-800'],
  [SiteSizeEnum.Medium, 'bg-site-secondary-green-700 hover:bg-site-secondary-green-800'],
  [SiteSizeEnum.Large, 'bg-site-secondary-green-600 hover:bg-site-secondary-green-700'],
  [SiteSizeEnum.XLarge, 'bg-site-secondary-green-600 hover:bg-site-secondary-green-700'],
]);

const buttonTertiarySizeClassesMap = new MatchedMap([
  [SiteSizeEnum.Small, 'hover:text-site-secondary-green-800'],
  [SiteSizeEnum.Medium, 'hover:text-site-secondary-green-800'],
  [SiteSizeEnum.Large, 'hover:text-site-secondary-green-700'],
  [SiteSizeEnum.XLarge, 'hover:text-site-secondary-green-700'],
]);

/**
 * Site Theme / Green Light Button Size Variant
 */

const buttonSizeClassesMap = (size: SiteSizeType) =>
  new MatchedMap([
    [SiteVariantEnum.Primary, buttonPrimarySizeClassesMap.get(SiteSizeEnum[size])],
    [SiteVariantEnum.Secondary, ''],
    [SiteVariantEnum.Tertiary, buttonTertiarySizeClassesMap.get(SiteSizeEnum[size])],
    [SiteVariantEnum.TextOnly, ''],
  ]);

/**
 * Site Theme / Green Light Button Color Variant
 */

const buttonSiteGreenLightTheme = (size: SiteSizeType) => ({
  buttonSiteVariantColorClasses: [
    buttonClassesMap,
    buttonHoverClassesMap,
    buttonActiveClassesMap,
    buttonSizeClassesMap(size),
  ],
  buttonSiteVariantColorShadowClasses: buttonShadowClasses,
});

export default buttonSiteGreenLightTheme;
